import { render } from "./ProductStats.vue?vue&type=template&id=c31a0830"
import script from "./ProductStats.vue?vue&type=script&lang=js"
export * from "./ProductStats.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__